import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { SECURITY_QUESTION_OPTIONS } from 'constants/signUp';
import { I18N } from 'commons';

const SecurityQuestionSection = ({ securityQuestion }) => (
  <div className="col-md-8">
    <label className="col-form-label" htmlFor="securityQuestion" id="securityQuestionLabel">
      <I18N>ssp.register.question</I18N>
    </label>
    <div>
      <Field
        component="select"
        name="securityQuestion"
        className="form-control"
        id="securityQuestion"
        aria-labelledby="securityQuestionLabel"
        value={securityQuestion}
        tabIndex="0"
      >
        {_.map(SECURITY_QUESTION_OPTIONS, question => (
          <I18N tag="option" value={question} key={question}>
            {question}
          </I18N>
        ))}
        <optgroup />
      </Field>
    </div>
  </div>
);

SecurityQuestionSection.propTypes = {
  securityQuestion: PropTypes.string.isRequired,
  resetLocationValues: PropTypes.func.isRequired,
  values: PropTypes.shape().isRequired,
};

export default SecurityQuestionSection;
